// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cbd631f9","404":"18b31710","787":"aadca95f"}[chunkId] + ".chunk.js";
};